import loopback from './loopback'

// Assinatura e cobranças da contratação, pelo pbxapi. O portal chamava o billing direto
// do navegador, com a chave do billing no bundle público; agora o pbxapi identifica a
// conta pela sessão e só repassa ao billing o que a contratação precisa (sem valor nem
// desconto vindos daqui). Os erros chegam com `errorCode` = a `key` do billing e são
// traduzidos pelo interceptor do loopback.js.
export const billingService = {
  calculateCycle (billingDay) {
    return loopback.get('/subscriptions/compute-cycle', { params: { billingDay } })
  },

  // O cliente do Asaas sai da integração gravada no pbxapi.
  createAccountConfig ({ financeEmails }) {
    return loopback.post('/subscriptions/account-config', { financeEmails })
  },

  getOpenInvoice () {
    return loopback.get('/subscriptions/open-invoice')
  },

  getPendingInvoices () {
    return loopback.get('/subscriptions/pending-invoices')
  },

  contractSubscription (payload) {
    return loopback.post('/subscriptions/contract', payload)
  }
}



// WEBPACK FOOTER //
// ./src/services/billing.js